exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".refreshbutton{margin-left:20px;display:flex;height:40px;align-items:center}.newContentAvailable{background-color:#4c9900!important}", ""]);

// exports
